export const OnRendered = {
    bind: (el, binding) => binding.value(el)
};